"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneDatabaseColumns = cloneDatabaseColumns;
/** A copied schema keeps database-scoped field IDs and row references. Self
 * relations follow the new identity; external relations become one-way so a
 * copy cannot mutate the original relation's inverse column. */
function cloneDatabaseColumns(columns, input) {
    if (!Array.isArray(columns)) {
        throw new Error('Database clone schema is unavailable');
    }
    return columns.map((value) => {
        if (!value || typeof value !== 'object' || Array.isArray(value)) {
            throw new Error('Database clone column is invalid');
        }
        const column = structuredClone(value);
        if (column.type !== 'relation' || !column.data)
            return column;
        if (typeof column.data !== 'object' || Array.isArray(column.data)) {
            throw new Error('Database clone relation is invalid');
        }
        const data = column.data;
        if (data.targetDatabaseId === input.sourceDatabaseId) {
            data.targetDatabaseId = input.targetDatabaseId;
            data.targetDocId = input.targetHostDocId;
        }
        else {
            data.targetDocId ??= input.sourceHostDocId;
            delete data.inverseFieldId;
            delete data.inverseCardinality;
        }
        return column;
    });
}
/** Read access to a database block's Y.Map (or plain snapshot) properties. */
